// 显示名称
export const NAME = 'name';

// 首页
export const HOMEPAGE = 'HomePage';

// 首页_banner跳转页
export const HOMEPAGE_BANNER_REDIRECT = 'HomePage.Banner.Redirect';

// 首页_搜索页
export const HOMEPAGE_SEARCH = 'HomePage.Search';

// 首页_搜索结果
export const HOMEPAGE_SEARCH_RESULT = 'HomePage.Search.Result';

// 消息中心首页
export const MESSAGECENTER_HOMEPAGE = 'MessageCenter.HomePage';

// 系统通知页
export const MESSAGECENTER_SYSTEMNOTIFICATION = 'MessageCenter.SystemNotification';

// 系统通知跳转页
export const MESSAGECENTER_SYSTEMNOTIFICATION_REDIRECT = 'MessageCenter.SystemNotification.Redirect';

// 点赞&收藏消息页
export const MESSAGECENTER_LIKEANDFAVORITES = 'MessageCenter.LikeAndFavorites';

// 关注消息页
export const MESSAGECENTER_FOLLOW = 'MessageCenter.Follow';

// 评论消息页
export const MESSAGECENTER_COMMENT = 'MessageCenter.Comment';

// 方案首页
export const SCHEME = 'Scheme';

// 方案_活动/广告跳转页
export const SCHEME_AD_REDIRECT = 'Scheme.AD.Redirect';

// 方案_3D方案详情
export const SCHEME_DETAILS = 'Scheme.Details';

// 方案_3D方案全景预览
export const SCHEME_PANORAMIC = 'Scheme.Panoramic';

// 方案_自定义方案详情
export const SCHEME_CUSTOM_DETAILS = 'Scheme.Custom.Details';

// 方案_空间模型
export const SCHEME_MODEL = 'Scheme.Model';

// 3D方案_全部评论页
export const SCHEME_3D_COMMENTS_ALL = 'Scheme.3D.Comments.All';

// 3D方案_回复评论页
export const SCHEME_3D_COMMENTS_REPLY = 'Scheme.3D.Comments.Reply';

// 自定义方案_全部评论页
export const SCHEME_CUSTOM_COMMENTS_ALL = 'Scheme.Custom.Comments.All';

// 自定义方案_回复评论页
export const SCHEME_CUSTOM_COMMENTS_REPLY = 'Scheme.Custom.Comments.Reply';

// 方案专栏详情页
export const SCHEME_COLUMN_DETAILS = 'Scheme.Column.Details';

// 美图详情页
export const SCHEME_MEITU_DETAILS = 'Scheme.Meitu.Details';

// 方案_搜索页
export const SCHEME_SEARCH = 'Scheme.Search';

// 方案_搜索结果页
export const SCHEME_SEARCH_RESULT = 'Scheme.Search.Result';

// 课程首页
export const COURSE = 'Course';

// 课程_活动/广告跳转页
export const COURSE_AD_REDIRECT = 'Course.AD.Redirect';

// 课程详情
export const COURSE_DETAILS_FREE = 'Course.Details.Free';

// 收费课程详情
export const COURSE_DETAILS_PAID = 'Course.Details.Paid';

// 免费直播跳转页
export const COURSE_LIVE_FREE_REDIRECT = 'Course.Live.Free.Redirect';

// 免费直播回看_站外
export const COURSE_LIVE_DETAILS_OUTLINK_FREE = 'Course.Live.Details.Outlink.Free';

// 免费直播回看_站内
export const COURSE_LIVE_DETAILS_STATION_FREE = 'Course.Live.Details.Station.Free';

// 课程专栏详情
export const COURSE_COLUMN_DETAILS = 'Course.Column.Details';

// 图文教程详情
export const COURSE_GRAPHICTUTORIAL_DETAILS = 'Course.GraphicTutorial.Details';

// 图文教程详情_全部评论
export const COURSE_GRAPHICTUTORIAL_DETAILS_COMMENTS_ALL = 'Course.GraphicTutorial.Details.Comments.All';

// 行业百科详情
export const COURSE_INDUSTRYENCYCLOPEDIA_DETAILS = 'Course.IndustryEncyclopedia.Details';

// 行业百科详情_全部评论
export const COURSE_INDUSTRYENCYCLOPEDIA_DETAILS_COMMENTS_ALL = 'Course.IndustryEncyclopedia.Details.Comments.All';

// 课程_搜索页
export const COURSE_SEARCH = 'Course.Search';

// 课程_搜索结果
export const COURSE_SEARCH_RESULT = 'Course.Search.Result';

// 社区首页
export const COMMUNITY = 'Community';

// 社区搜索页
export const COMMUNITY_SEARCH = 'Community.Search';

// 社区_发帖子页
export const COMMUNITY_POST = 'Community.Post';

// 社区_帖子详情页
export const COMMUNITY_POSTDETAILS = 'Community.PostDetails';

// 社区_话题
export const COMMUNITY_TOPICOFCONVERSATION = 'Community.TopicOfConversation';

// 社区_话题详情页
export const COMMUNITY_TOPICDETAILS = 'Community.TopicDetails';

// 素材首页
export const MATERIAL = 'Material';

// 素材_活动/广告跳转页
export const MATERIAL_AD_REDIRECT = 'Material.AD.Redirect';

// 场景模型详情
export const MATERIAL_SCENEMODEL_DETAILS = 'Material.SceneModel.Details';

// 组合模型详情
export const MATERIAL_COMBINEDMODEL_DETAILS = 'Material.CombinedModel.Details';

// 单体模型详情
export const MATERIAL_SINGLEMODEL_DETAILS = 'Material.SingleModel.Details';

// 模型专栏详情
export const MATERIAL_COLUMNMODEL_DETAILS = 'Material.ColumnModel.Details';

// 素材_搜索
export const MATERIAL_SEARCH = 'Material.Search';

// 素材搜索结果
export const MATERIAL_SEARCH_RESULT = 'Material.Search.Result';

// 设计师列表页
export const DESIGNER_BIGSHOT = 'Designer.BigShot';

// 设计师榜单
export const DESIGNER_TOP = 'Designer.Top';

// 设计师榜单_上榜规则
export const DESIGNER_TOP_LISTINGRULES = 'Designer.Top.ListingRules';

// 设计师榜单_立即冲榜
export const DESIGNER_TOP_JOIN = 'Designer.Top.Join';

// 本人主页
export const DESIGNER_HOMEPAGEOFSELF = 'Designer.HomePageOfSelf';

// 本人关注列表
export const DESIGNER = 'Designer';

// 他人主页
export const DESIGNER_HOMEPAGEOFOTHERS = 'Designer.HomePageOfOthers';

// 他人主页_不允许查看
export const DESIGNER_HOMDEPAGEOFOTHERS_NOTALLOW = 'Designer.HomdePageOfOthers.NotAllow';

// 他人关注列表
export const DESIGNER_HOMEPAGEOFOTHERS_FOLLOW = 'Designer.HomePageOfOthers.Follow';

// 设计师主页_3D方案详情
export const DESIGNER_HOMEPAGE_SCHEME_DETAILS = 'Designer.HomePage.Scheme.Details';

// 设计师主页_自定义方案详情
export const DESIGNER_HOMEPAGE_SCHEME_CUSTOM_DETAILS = 'Designer.HomePage.Scheme.Custom.Details';

// 营销获客首页
export const WORKBENCH_MARKETING = 'Workbench.Marketing';

// 易量尺首页_待量尺
export const WORKBENCH_YILIANGCHI_TOSURVEY = 'Workbench.YiLiangChi.ToSurvey';

// 易量尺首页_待涉及
export const WORKBENCH_YILIANGCHI_SURVEYED = 'Workbench.YiLiangChi.Surveyed';

// 我的设计首页
export const WORKBENCH_MYDESIGN = 'Workbench.MyDesign';

// 营销获客_选择方案投稿
export const WORKBENCH_MARKETING_CHOOSE_TOCONTRIBUTION = 'Workbench.Marketing.Choose.ToContribution';

// 营销获客_选择方案生成海报
export const WORKBENCH_MARKETING_CHOOSE_GENERATEPOSTER = 'Workbench.Marketing.Choose.GeneratePoster';

// 营销获客_生成作品海报
export const WORKBENCH_MARKETING_GENERATEPOSTER = 'Workbench.Marketing.GeneratePoster';

// 营销获客_数据分析
export const WORKBENCH_DATAANALYSIS = 'Workbench.DataAnalysis';

// 易量尺_客户详情
export const WORKBENCH_YILIANGCHI_CLIENTDETAIL = 'Workbench.YiLiangChi.ClientDetail';

// 易量尺_添加客户
export const WORKBENCH_YILIANGCHI_ADDCLIENT = 'Workbench.YiLiangChi.AddClient';

// 易量尺_编辑客户
export const WORKBENCH_YILIANGCHI_UPDATECLIENT = 'Workbench.YiLiangChi.UpdateClient';

// 易量尺_客户量尺
export const WORKBENCH_YILIANGCHI_SURVEY = 'Workbench.YiLiangChi.Survey';

// 客户量尺_草图
export const WORKBENCH_YILIANGCHI_SURVEY_SKETCH = 'Workbench.YiLiangChi.Survey.Sketch';

// 客户量尺_鸟瞰图
export const WORKBENCH_YILIANGCHI_SURVEY_AERIALVIEW = 'Workbench.YiLiangChi.Survey.AerialView';

// 客户量尺_漫游图
export const WORKBENCH_YILIANGCHI_SURVEY_ROAMINGGRAPH = 'Workbench.YiLiangChi.Survey.RoamingGraph';

// 客户量尺_现场照片
export const WORKBENCH_YILIANGCHI_SURVEY_LIVEPHOTO = 'Workbench.YiLiangChi.Survey.LivePhoto';

// 我的设计_方案详情_3D方案
export const WORKBENCH_MYDESIGN_SCHEMEDETAIL_3D = 'Workbench.MyDesign.SchemeDetail.3D';

// 我的设计_方案编辑_3D方案
export const WORKBENCH_MYDESIGN_SCHEMEDETAIL_3D_UPDATE = 'Workbench.MyDesign.SchemeDetail.3D.Update';

// 我的设计_方案投稿渠道选择
export const WORKBENCH_MYDESIGN_CHOOSECHANNEL = 'Workbench.MyDesign.ChooseChannel';

// 我的设计_方案详情_自定义方案
export const WORKBENCH_MYDESIGN_SCHEMEDETAIL_CUSTOMIZE = 'Workbench.MyDesign.SchemeDetail.Customize';

// 我的设计_方案编辑_自定义方案
export const WORKBENCH_MYDESIGN_SCHEMEDETAIL_CUSTOMIZE_UPDATE = 'Workbench.MyDesign.SchemeDetail.Customize.Update';

// 我的首页
export const PERSONALCENTER = 'PersonalCenter';

// 编辑资料
export const PERSONALCENTER_UPDATEPROFILE = 'PersonalCenter.UpdateProfile';

// 咨询联系
export const PERSONALCENTER_CONTACT = 'PersonalCenter.Contact';

// 咨询联系_IM页
export const PERSONALCENTER_CONTACT_IM = 'PersonalCenter.Contact.IM';

// 我的投稿
export const PERSONALCENTER_MYCONTRIBUTION = 'PersonalCenter.MyContribution';

// 我的投稿_搜索页
export const PERSONALCENTER_MYCONTRIBUTION_SEARCH = 'PersonalCenter.MyContribution.Search';

// 我的投稿_搜索结果
export const PERSONALCENTER_MYCONTRIBUTION_SEARCHRESULT = 'PersonalCenter.MyContribution.SearchResult';

// 签到
export const PERSONALCENTER_SIGNIN = 'PersonalCenter.SignIn';

// 积分市场
export const PERSONALCENTER_POINTSMARKET = 'PersonalCenter.PointsMarket';

// 获取积分
export const PERSONALCENTER_POINTSMARKET_GETPOINTS = 'PersonalCenter.PointsMarket.GetPoints';

// 礼品详情
export const PERSONALCENTER_POINTSMARKET_GIFTDETAIL = 'PersonalCenter.PointsMarket.GiftDetail';

// 我的课程
export const PERSONALCENTER_MYCOURSE = 'PersonalCenter.MyCourse';

// 我的课程_搜索页
export const PERSONALCENTER_MYCOURSE_SEARCH = 'PersonalCenter.MyCourse.Search';

// 我的课程_搜索结果
export const PERSONALCENTER_MYCOURSE_SEARCHRESULT = 'PersonalCenter.MyCourse.SearchResult';

// 我的收藏
export const PERSONALCENTER_FAVORITES = 'PersonalCenter.Favorites';

// 我的收藏_搜索页
export const PERSONALCENTER_FAVORITES_SEARCH = 'PersonalCenter.Favorites.Search';

// 我的收藏_搜索结果
export const PERSONALCENTER_FAVORITES_SEARCHRESULT = 'PersonalCenter.Favorites.SearchResult';

// 我的关注
export const PERSONALCENTER_FOLLOW = 'PersonalCenter.Follow';

// 我的关注_搜索
export const PERSONALCENTER_FOLLOW_SEARCH = 'PersonalCenter.Follow.Search';

// 我的关注_搜索结果页
export const PERSONALCENTER_FOLLOW_SEARCHRESULT = 'PersonalCenter.Follow.SearchResult';

// 帮助与反馈
export const PERSONALCENTER_HELP = 'PersonalCenter.Help';

// 帮助与反馈_常见问题
export const PERSONALCENTER_HELP_QUESTION_DETAIL = 'PersonalCenter.Help.Question.Detail';

// 意见反馈
export const PERSONALCENTER_HELP_FEEDBACK = 'PersonalCenter.Help.Feedback';

// 意见反馈_反馈详情
export const PERSONALCENTER_HELP_FEEDBACK_DETAIL = 'PersonalCenter.Help.Feedback.Detail';

// 联系客服
export const PERSONALCENTER_CUSTOMERSERVICE = 'PersonalCenter.CustomerService';

// 系统设置
export const PERSONALCENTER_SETTINGS = 'PersonalCenter.Settings';

// 账号安全
export const PERSONALCENTER_SETTINGS_SAFETY = 'PersonalCenter.Settings.Safety';

// 修改密码
export const PERSONALCENTER_SETTINGS_UPDATEPASSWORD = 'PersonalCenter.Settings.UpdatePassword';

// 更改手机号_步骤1
export const PERSONALCENTER_SETTINGS_UPDATEPHONE_STEP1 = 'PersonalCenter.Settings.UpdatePhone.Step1';

// 更改手机号_步骤2
export const PERSONALCENTER_SETTINGS_UPDATEPHONE_STEP2 = 'PersonalCenter.Settings.UpdatePhone.Step2';

// 更改/绑定邮箱
export const PERSONALCENTER_SETTINGS_UPDATEEMAIL = 'PersonalCenter.Settings.UpdateEmail';

// 关于三维家设计师
export const PERSONALCENTER_SETTINGS_ABOUT = 'PersonalCenter.Settings.About';

// 我的动态
export const MYNEWS = 'MyNews';

// 登录
export const LOGIN = 'Login';

// 服务市场
export const SERVICE_MARKET = 'Service.Market';

// 服务详情
export const SERVICE_DETAILS = 'Service.Details';

// 我的订单
export const MYORDER = 'MyOrder';

// 下单
export const ORDER = 'Order';

// 订单详情
export const ORDER_DETAILS = 'Order.Details';

// 积分记录
export const PERSONALCENTER_POINTSMARKET_RECORDS = 'PersonalCenter.PointsMarket.Records';

// 积分抽奖
export const PERSONALCENTER_POINTSMARKET_LOTTERY = 'PersonalCenter.PointsMarket.Lottery';

// 编辑收件信息
export const PERSONALCENTER_POINTSMARKET_EDITINFO = 'PersonalCenter.PointsMarket.EditInfo';

// 积分规则
export const PERSONALCENTER_POINTSMARKET_RULES = 'PersonalCenter.PointsMarket.Rules';

// 抽奖说明
export const PERSONALCENTER_LOTTERY_DESCRIPTION = 'PersonalCenter.Lottery.Description';

// 积分礼品
export const PERSONALCENTER_POINTSMARKET_GIFT = 'PersonalCenter.PointsMarket.Gift';

// 礼品详情_已获取
export const PERSONALCENTER_POINTSMARKET_GIFTDETAIL_ACQUIRED = 'PersonalCenter.PointsMarket.GiftDetail.Acquired';

// 新用户礼包__端内
export const HOMEPAGE_NEWUSER = 'HomePage.NewUser';

// 新用户礼包__端外
export const HOMEPAGE_NEWUSER__OUTSIDE = 'HomePage.NewUser.OutSide';

// 邀请活动
export const PERSONALCENTER_INVITE = 'PersonalCenter.Invite';

// 邀请活动_端外
export const PERSONALCENTER_INVITE_OUTSITE = 'PersonalCenter.Invite.OutSite';

// 查看往期活动
export const PERSONALCENTER_INVITE_PAST = 'PersonalCenter.Invite.Past';

// 往期活动详情
export const PERSONALCENTER_INVITE_PAST_DETAILS = 'PersonalCenter.Invite.Past.Details';

// 邀请活动礼品详情
export const PERSONALCENTER_INVITE_GIFTDETAILS = 'PersonalCenter.Invite.GiftDetails';

// 我的渲染券
export const MYRENDERINGCOUPON = 'MyRenderingCoupon';

// 1.9.0新增页面
export const UNIT = 'Unit';
// 户型详情
export const UNIT_DETAILS = 'Unit.Details';

// 培训详情
export const COURSE_TRAINING_DETAILS = 'Course.Training.Details';

// 培训地图
export const COURSE_TRAINING_ADDRESS = 'Course.Training.Address';

// 培训报名
export const COURSE_TRAINING_APPLY = 'Course.Training.Apply';

// 培训搜索列表
export const COURSE_TRAINING_SEARCH = 'Course.Training.Search';

// 培训列表
export const COURSE_TRAINING = 'Course.Training';

// 文章动态详情
export const COMMUNITY_ARTICLE_DETAILS = 'Community.Article.Details';

// 7天试用活动落地页
export const ACTIVITY_SEVENDAY_FREE = 'Activity.SevenDay.Free';

// 7天试用活动下单页
export const ACTIVITY_SEVENDAY_FREE_APPLY = 'Activity.SevenDay.Free.Apply';

// 神笔视频详情
export const WORKBENCH_MARKETING_MAGICPEN_DETAIL = 'Workbench.Marketing.MagicPen.Detail';

/** 1.12.0新增 */
// 我的家
export const MYHOME = 'MyHome';

// 编辑我的家
export const MYHOME_EDIT = 'MyHome.Edit';

// 通用地图
export const MAP = 'Map';

/** 2.1.0新增 */
export const COUPONCENTER = 'CouponCenter';

export const H5 = 'H5';

/** 2.3.0新增 */
export const QUOTEDPRICE = 'QuotedPrice';

export const QUOTEDPRICE_RESULT = 'QuotedPrice.Result';
